<template>
  <div>
    <data-table :service="PaymentTypeService"
                :entity="entity"
                :columns="columns"
                :disablePermissionChecks="true"
                operations="refresh"
                ref="table">
      <template v-slot:created_at="{row}">
        {{$formatDate(row.created_at)}}
      </template>
      <template v-slot:third_party="{row}">
        {{row.third_party || '--'}}
      </template>
      <template v-slot:type="{row}">
        <status-badge type="primary" :status="row.type">
          {{row.type}}
        </status-badge>
      </template>
      <template v-slot:active="{row}">
        <base-switch :value="row.active" @input="onActiveChange($event, row)"/>
      </template>

    </data-table>
  </div>
</template>
<script>
  import PaymentTypeService from 'src/services/PaymentTypeService'
  import { entities } from 'src/config/routeTypes'

  export default {
    name: 'products-settings',
    data () {
      return {
        PaymentTypeService,
        entity: entities.PAYMENT_TYPE
      }
    },
    computed: {
      columns () {
        return [
          {
            prop: 'name',
            label: this.$t('generic.name'),
            minWidth: '200px',
            sortable: true
          },
          {
            prop: 'type',
            label: this.$t('settings.payments.labels.type'),
            minWidth: '170px',
            sortable: true
          },
          {
            prop: 'third_party',
            label: this.$t('settings.payments.labels.third_party'),
            minWidth: '170px',
            sortable: true
          },
          {
            prop: 'active',
            label: this.$t('generic.active'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'created_at',
            label: this.$t('generic.createdAt'),
            minWidth: '170px',
            sortable: true
          }
        ]
      }
    },
    methods: {
      async onActiveChange(value, row) {
        const data = {
          ...row,
          active: value
        }
        await PaymentTypeService.update(data.id, data)
        this.$set(row, 'active', value)
      }
    }
  }
</script>
<style>
</style>
